import {Store} from "vuex";

/** Representation of one second in milliseconds. */
let ONE_SECOND = 0;
let interval: any;

/** Sets a countdown timer from the present moment to the given date.
 * @param countDownDate the date we're counting down to (in milliseconds).
 * @param callback callback that will be called once the timer has finished counting down.
 */
export const setCountdownTimer = async (
  countDownDate: number,
  callback: () => Promise<void>,
  store: Store<any>
) => {
  interval = setInterval(async () => {
    if (ONE_SECOND === 0) {
      ONE_SECOND = 1000;
    }

    const now = new Date().getTime();
    const distance = countDownDate - now;

    if (distance < 0) {
      clearInterval(interval);
      await callback();
      return;
    }

    await store.dispatch("question_module/setTimeCounter", distance);
    return formatTime(distance);
  }, ONE_SECOND);
};

/** Clears the current timer interval that's running. */
export const clearTimerInterval = async (store: Store<any>) => {
  clearInterval(interval);
  await store.dispatch("question_module/setTimeCounter", 0);
};

/** Formats a given time in milliseconds to  --d--h--m--s.
 * @param time period of time in milliseconds.
 */
export const formatTime = (time: number): string => {
  const days = Math.floor(time / (1000 * 60 * 60 * 24));
  const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((time % (1000 * 60)) / 1000);
  let formattedTime = "";
  if (days) formattedTime = formattedTime + days + "d ";
  if (hours) formattedTime = formattedTime + hours + "h ";
  if (minutes) formattedTime = formattedTime + minutes + "m ";
  return formattedTime + seconds + "s";
};
